'use client';

import { memo } from 'react';
import { usePrefillCartFromUrl } from '@/features/prefill-cart';
import { useVenueRouterSessionHandler } from '@/features/venue-router';

export const AppBootSideEffects = memo(() => {
    usePrefillCartFromUrl();
    useVenueRouterSessionHandler();
    return null;
});
AppBootSideEffects.displayName = 'AppBootSideEffects';
